// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-weight: 900;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-weight: 900;
  font-style: normal;
}
body {
  margin: 0;
  font-family: Roboto !important;
  font-weight: 400;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

input,
select,
option,
textarea,
button,
a {
  font-family: Roboto;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

html,
body,
#root,
#root > div {
  height: 100%;
}

.anticon-star {
  font-size: 14px;
  margin-right: 1px;
}

.react-joyride__tooltip h4 {
  color: white;
  font-size: 16px !important;
  padding: 40px 0 0;
  margin-bottom: 0;
}

.react-joyride__spotlight {
  border-radius: 10px !important;
}

.ant-table-thead > tr > th {
  background: rgba(220, 244, 255, 0.5058823529) !important;
}

@media screen and (max-width: 1000px) {
  .ant-layout-header {
    padding: 0 10px !important;
  }
}

.ant-collapse {
  margin-bottom: 10px;
}

.react-joyride__overlay {
  z-index: 100000 !important;
}

.__floater__open {
  z-index: 9999999 !important;
}

.loading_lang {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(109, 108, 108, 0.445);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ant-modal-header {
  border-radius: 20px 20px 0 0 !important;
}

.ant-modal-content {
  border-radius: 20px !important;
}

.ant-progress-circle.ant-progress-status-success .ant-progress-text {
  color: #00955f !important;
}

a:focus-visible,
button:focus-visible {
  outline: rgb(28, 214, 106) !important;
  outline-width: 2px !important;
  outline-style: groove !important;
  outline-offset: 2px;
}

@media screen and (max-width: 1000px) {
  .ant-pagination {
    margin-top: 10px !important;
  }
}

.ant-form-item-explain.ant-form-item-explain-error {
  color: rgba(255, 0, 0, 0.6) !important;
  font-size: 14px;
}

.ant-table-thead > tr > th {
  color: #aeaeae !important;
  font-size: 14px;
}

.ant-pagination-item-link {
  border: none !important;
  background: transparent !important;
}

.ant-pagination-item {
  border: none !important;
  background: transparent !important;
}

.ant-pagination-item-active a {
  color: #00955f !important;
}

.ant-pagination-item:focus-visible a,
.ant-pagination-item:hover a,
.ant-pagination-prev:hover .ant-pagination-item-link,
.ant-pagination-next:hover .ant-pagination-item-link {
  color: #00955f !important;
}

.ant-pagination-disabled svg {
  color: rgba(107, 107, 107, 0.5725490196);
}

.ant-tabs-tab {
  background-color: rgba(182, 182, 182, 0.262745098) !important;
  color: #aeaeae !important;
  font-size: 16px !important;
  border-radius: 2px !important;
  margin-right: 15px !important;
}

.ant-tabs-tab-active {
  background-color: #ffffff !important;
  color: #00955f !important;
}

.ant-tabs-tab-btn:focus {
  color: #00955f !important;
}

.ant-tabs-nav:before {
  border: none !important;
}

.ant-upload-select-picture-card,
.ant-upload-list-picture-card-container {
  width: 200px !important;
  height: 200px !important;
}

.ant-upload.ant-upload-select-picture-card {
  background-color: #eafef7 !important;
  border: 1px solid #00955f !important;
}

.ant-popover-inner {
  border-radius: 10px !important;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15) !important;
}

.pdf_link {
  max-width: -webkit-fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  display: block;
}

.ant-popover {
  max-width: 550px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/App.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,6CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADA;EACE,qBAAA;EACA,6CAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AAAA;EACE,SAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;AAEF;;AAAA;;;;;;EAME,mBAAA;AAGF;;AAAA;EACE,+EAAA;AAGF;;AAAA;;;;EAIE,YAAA;AAGF;;AAAA;EACE,eAAA;EACA,iBAAA;AAGF;;AAAE;EACE,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;AAGJ;;AAKA;EACE,8BAAA;AAFF;;AAIA;EACE,wDAAA;AADF;;AAIE;EADF;IAEI,0BAAA;EAAF;AACF;;AAEA;EACE,mBAAA;AACF;;AACA;EACE,0BAAA;AAEF;;AAAA;EACE,2BAAA;AAGF;;AAAA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGF;;AADA;EACE,uCAAA;AAIF;;AAFA;EACE,8BAAA;AAKF;;AAFA;EACE,yBAAA;AAKF;;AAFA;;EAEE,qCAAA;EACA,6BAAA;EACA,gCAAA;EACA,mBAAA;AAKF;;AAFE;EADF;IAEI,2BAAA;EAMF;AACF;;AAHA;EACE,sCAAA;EACA,eAAA;AAMF;;AAHA;EACE,yBAAA;EACA,eAAA;AAMF;;AAHA;EACE,uBAAA;EACA,kCAAA;AAMF;;AAJA;EACE,uBAAA;EACA,kCAAA;AAOF;;AALA;EACE,yBAAA;AAQF;;AANA;;;;EAIE,yBAAA;AASF;;AANA;EACE,wCAAA;AASF;;AANA;EACE,6DAAA;EACA,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,6BAAA;AASF;;AANA;EACE,oCAAA;EACA,yBAAA;AASF;;AAPA;EACE,yBAAA;AAUF;;AARA;EACE,uBAAA;AAWF;;AATA;;EAEE,uBAAA;EACA,wBAAA;AAYF;;AATA;EACE,oCAAA;EACA,oCAAA;AAYF;;AAVA;EACE,8BAAA;EACA,2DAAA;AAaF;;AAXA;EACE,8BAAA;EAAA,2BAAA;EAAA,sBAAA;EACA,cAAA;AAcF;;AAXA;EACE,2BAAA;AAcF","sourcesContent":["@import \"./variables.scss\";\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-Thin.ttf\");\n  font-weight: 200;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-ThinItalic.ttf\");\n  font-weight: 100;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-LightItalic.ttf\");\n  font-weight: 100;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-Light.ttf\");\n  font-weight: 300;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-Regular.ttf\");\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-Italic.ttf\");\n  font-weight: 400;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-MediumItalic.ttf\");\n  font-weight: 500;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-Medium.ttf\");\n  font-weight: 500;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-BoldItalic.ttf\");\n  font-weight: 700;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-Bold.ttf\");\n  font-weight: 700;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-BlackItalic.ttf\");\n  font-weight: 900;\n  font-style: italic;\n}\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../assets/fonts/Roboto-Black.ttf\");\n  font-weight: 900;\n  font-style: normal;\n}\n\nbody {\n  margin: 0;\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\ninput,\nselect,\noption,\ntextarea,\nbutton,\na {\n  font-family: Roboto;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\nhtml,\nbody,\n#root,\n#root > div {\n  height: 100%;\n}\n\n.anticon-star {\n  font-size: 14px;\n  margin-right: 1px;\n}\n.react-joyride__tooltip {\n  h4 {\n    color: white;\n    font-size: 16px !important;\n    padding: 40px 0 0;\n    margin-bottom: 0;\n  }\n\n  // button[aria-label=\"Next Step\"],\n  // button[aria-label=\"Last\"] {\n  //   color: $font-clor !important;\n  // }\n}\n.react-joyride__spotlight {\n  border-radius: 10px !important;\n}\n.ant-table-thead > tr > th {\n  background: #dcf4ff81 !important;\n}\n.ant-layout-header {\n  @media screen and (max-width: 1000px) {\n    padding: 0 10px !important;\n  }\n}\n.ant-collapse {\n  margin-bottom: 10px;\n}\n.react-joyride__overlay {\n  z-index: 100000 !important;\n}\n.__floater__open {\n  z-index: 9999999 !important;\n}\n\n.loading_lang {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(109, 108, 108, 0.445);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ant-modal-header {\n  border-radius: 20px 20px 0 0 !important;\n}\n.ant-modal-content {\n  border-radius: 20px !important;\n}\n\n.ant-progress-circle.ant-progress-status-success .ant-progress-text {\n  color: $font-clor !important;\n}\n\na:focus-visible,\nbutton:focus-visible {\n  outline: rgb(28, 214, 106) !important;\n  outline-width: 2px !important;\n  outline-style: groove !important;\n  outline-offset: 2px;\n}\n.ant-pagination {\n  @media screen and (max-width: 1000px) {\n    margin-top: 10px !important;\n  }\n}\n\n.ant-form-item-explain.ant-form-item-explain-error {\n  color: rgba(255, 0, 0, 0.6) !important;\n  font-size: 14px;\n}\n\n.ant-table-thead > tr > th {\n  color: #aeaeae !important;\n  font-size: 14px;\n}\n\n.ant-pagination-item-link {\n  border: none !important;\n  background: transparent !important;\n}\n.ant-pagination-item {\n  border: none !important;\n  background: transparent !important;\n}\n.ant-pagination-item-active a {\n  color: $font-clor !important;\n}\n.ant-pagination-item:focus-visible a,\n.ant-pagination-item:hover a,\n.ant-pagination-prev:hover .ant-pagination-item-link,\n.ant-pagination-next:hover .ant-pagination-item-link {\n  color: $font-clor !important;\n}\n\n.ant-pagination-disabled svg {\n  color: #6b6b6b92;\n}\n\n.ant-tabs-tab {\n  background-color: #b6b6b643 !important;\n  color: #aeaeae !important;\n  font-size: 16px !important;\n  border-radius: 2px !important;\n  margin-right: 15px !important;\n}\n\n.ant-tabs-tab-active {\n  background-color: #ffffff !important;\n  color: $font-clor !important;\n}\n.ant-tabs-tab-btn:focus {\n  color: $font-clor !important;\n}\n.ant-tabs-nav:before {\n  border: none !important;\n}\n.ant-upload-select-picture-card,\n.ant-upload-list-picture-card-container {\n  width: 200px !important;\n  height: 200px !important;\n}\n\n.ant-upload.ant-upload-select-picture-card {\n  background-color: #eafef7 !important;\n  border: 1px solid #00955f !important;\n}\n.ant-popover-inner {\n  border-radius: 10px !important;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15) !important;\n}\n.pdf_link {\n  max-width: fit-content;\n  display: block;\n}\n\n.ant-popover{\n  max-width: 550px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `rgba(1, 83, 34, 0.7)`
};
export default ___CSS_LOADER_EXPORT___;
